<template>
  <div class="container_box details_box_styles">
    <!--头部信息区域-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <Row type="flex" :gutter="gutterItem">
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ configCharacters(false) + 'SPU：' }}</span>
            <span class="basic_txt">{{ skuInfo.ymsSpu }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ configCharacters() + $t('key1000597') }}</span>
            <span class="basic_txt">{{ skuInfo.ymsProductCategoryName }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1000598') }}</span>
            <span class="basic_txt">{{ skuInfo.shelveStatusTxt }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1000599') }}</span>
            <span class="basic_txt" :title="skuInfo.name">{{ skuInfo.name }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1000601') }}</span>
            <span>{{ skuInfo.skuNumber }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1000602') }}</span>
            <span>{{ skuInfo.productGoodsTotalNumber }}</span>
          </Col>
        </Row>
      </Card>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="tableDom"
        highlight-row
        border
        max-height="650"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        :span-method="handleSpan">
      </Table>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getBatchCategoryInfoData, setConfigCharacters, getSpanMethod, getDataSetBatchList, getEnumName} from "@/utils/common";

export default {
  name: "viewCollectSku",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      ItemCol: 8,
      pageParamsStatus: false,
      ymsProductId: null,
      skuInfo: {},
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000585'),
          key: 'pictureUrl',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            return v.tableImg(h, params, 'productGoodsImage');
          }
        },
        {
          title: `${setConfigCharacters(false)}SKU`,
          key: 'ymsSku',
          align: 'center',
          minWidth: 180
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000587'),
          minWidth: 140,
          key: 'specifications',
          align: 'center',
          render(h, params) {
            if (params.row.productGoodsSpecifications) {
              return h('div', {
                style: {
                  color: 'green'
                }
              }, params.row.productGoodsSpecifications.map(i => {
                return h('p', i.name + ':' + i.value);
              }));
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000590'),
          key: 'status',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            let status = params.row.status;
            let title = getEnumName(v.enumData, 'YmsProductInfoShelveStatusCoreEnum', status, 'number');
            return h('div', title);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001111'),
          key: 'lwh',
          align: 'center',
          minWidth: 140,
          render: (h, params) => {
            let {length, width, height} = params.row;
            let text = length + ' * ' + width + ' * ' + height;
            return h('span', text)
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000589'),
          key: 'weight',
          align: 'center',
          minWidth: 120
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000241'),
          key: 'warehouseName',
          align: 'left',
          minWidth: 160,
          render(h, params) {
            let {warehouseName, ymsWarehouseName} = params.row;
            let name = warehouseName || ymsWarehouseName;
            return h('span', name)
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005752'),
          key: 'availableNumber',
          align: 'center',
          minWidth: 160,
          render(h, params) {
            return h('span', params.row.skuAvailableNumber || 0)
          }
        }
      ],
      tableData: [],
      productGoodsId: null,
      productColorImageList: [],
      enumData: []
    };
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    async initData() {
      let enumKeyList =['YmsProductInfoShelveStatusCoreEnum'];
      this.enumData = await getDataSetBatchList(enumKeyList);
      let query = this.$route.query;
      if (query) {
        this.ymsProductId = query.ymsProductId;
        this.getSkuData(this.ymsProductId);
      }
    },
    // 获取查看sku的数据
    getSkuData(ymsProductId) {
      let v = this;
      v.optionBtnWidth = [];
      v.tableData = [];
      v.axios.get(api.get_ymsDistributorProductInfo_queryForSkuList + ymsProductId, {loading: true}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            // 云卖分类
            let ymsProductCategoryId = data.ymsProductCategoryId;
            let url = v.system === 'yms' ? api.post_ymsProductCategory_queryByYmsProductCategoryIds : api.post_ymsProductCategory_api_queryDetailByCategoryIds;
            getBatchCategoryInfoData(url, null, [ymsProductCategoryId], true).then((newData) => {
              if (newData.length > 0) {
                newData.map((item) => {
                  if (item.ymsProductCategoryId === ymsProductCategoryId) {
                    let txt = item.productCategoryNavigation.split('->');
                    data.ymsProductCategoryName = txt.join(' / ');
                  }
                });
              }
            });
            // 商品状态
            let shelveStatus = data.shelveStatus;
            data.shelveStatusTxt = getEnumName(v.enumData, 'YmsProductInfoShelveStatusCoreEnum', shelveStatus, 'number');
            v.skuInfo = data;
            v.productColorImageList = data.productColorImageList || [];
            let productGoodsList = data.productGoodsList || [];
            // 处理货品数据
            if (productGoodsList.length > 0) {
              const newList = [];
              productGoodsList.map((item) => {
                const {ymsProductGoodsPrices, availableWarehouses, ...vals} = item;
                const productGoodsPricesList = ymsProductGoodsPrices || [];
                const wmsInventoriesList = availableWarehouses || [];
                // 组装国家供货价数据对象
                const productGoodsPricesObj = {};
                productGoodsPricesList.forEach(ele => {
                  const countryCode = ele.countryCode;
                  productGoodsPricesObj[`${countryCode}_supplyPrice`] = ele.supplyPrice;
                });
                // 遍历库存数据列表合并
                if (wmsInventoriesList.length > 0) {
                  wmsInventoriesList.forEach(ele => {
                    const obj = {
                      ...ele,
                      ...productGoodsPricesObj,
                      ymsWarehouseName: ele.name,
                      skuAvailableNumber: ele.availableNumber,
                      ...vals,
                    };
                    newList.push(obj);
                  });
                } else {
                  const obj = {
                    ...productGoodsPricesObj,
                    ymsWarehouseName: '-', // 或 “暂无仓库”
                    skuAvailableNumber: 0,
                    ...vals,
                  };
                  newList.push(obj);
                }
              });
              v.handleTableData(newList);
            }
          }
        }
      });
    },
    // 处理列表数据
    handleTableData(data) {
      if (!data?.length) {
        this.tableData = data || [];
        this.updateTableDom('tableDom');
        return;
      }
      data.forEach(item => {
        let ymsWarehouseDeliverySettings = item.ymsWarehouseDeliverySettings || [];
        let isDeliveryWarehouseTalg = item.isDeliveryWarehouse === 1 && ymsWarehouseDeliverySettings.length > 0;
        item.isDeliveryWarehouseTalg = isDeliveryWarehouseTalg || false;
      });
      this.tableData = data;
      this.updateTableDom('tableDom');
    },
    // 合并单元格
    handleSpan({row, column, rowIndex, columnIndex}) {
      let colKeys = ['pictureUrl', 'originalYmsSku', 'ymsSku', 'specifications', 'status', 'lwh', 'weight', 'options'];
      this.tableColumns.map((item) => {
        for (let key in item) {
          if (key.includes('_supplyPrice')) {
            colKeys.push(key);
          }
        }
      })
      colKeys = this.uniqueFunc(colKeys);
      return getSpanMethod(this.tableData, colKeys, 'ymsProductGoodsId', row, column, rowIndex, columnIndex)
    },
  }
};
</script>

<style lang="less" scoped>
.basic_txt {
  max-width: 320px !important;
}

.red_txt {
  color: #E41E09;
}

</style>
